module.exports = __webpack_public_path__ + "img/far-file-invoice-dollar.0206de54.svg";